import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';
import { siteInfo } from '@/mocks/site';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 hover:text-primary-500 transition-colors cursor-pointer"
          >
            <span className="text-2xl font-heading font-bold tracking-wide">
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
            <a
              href={`https://qm.qq.com/q/${siteInfo.qqGroupNumber}`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              QQ吃瓜群
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="切换菜单"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3">
            <div className="flex flex-col gap-1 px-4">
              <Link
                to="/"
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-lg whitespace-nowrap cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                关于我们
              </Link>
              <a
                href={`https://qm.qq.com/q/${siteInfo.qqGroupNumber}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="px-3 py-2.5 text-sm font-semibold text-primary-500 hover:bg-primary-50 rounded-lg whitespace-nowrap cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                QQ吃瓜群
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}